import { render, staticRenderFns } from "./TransferDetail.vue?vue&type=template&id=6b472a46&scoped=true&"
import script from "./TransferDetail.vue?vue&type=script&lang=js&"
export * from "./TransferDetail.vue?vue&type=script&lang=js&"
import style0 from "./TransferDetail.vue?vue&type=style&index=0&id=6b472a46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b472a46",
  null
  
)

export default component.exports